import React, { useState, useContext, useReducer } from "react";
import GlobalContext    from "../../isp._comun/iu/contexto/GlobalContext";

import QueryServicioReducer         from "../reductores/QueryServicioReducer";
import CargaDeServiciosBuscados from "../reductores/acciones/dispatch/CargaDeServiciosBuscados";
import FinalizarComando         from "../reductores/acciones/dispatch/FinalizarComando";

import * as TipoDeError from "../../isp._comun/services/Errores";

import ServicioQueryServicios from "../../isp.žapi.servicios/ServiceQueryServicios";
// import useHandlerDeComandoConSesionActiva from "../../../principal/componentes/presentadores/useHandlerDeComandoConSesionActiva";
import ComandoAPI from "../../isp._comun/iu/componentes/ComandoAPI";
import DialogoQueryServiciosLayout from "./layouts/DialogoQueryServiciosLayout";

const DialogoQueryServicios = ({ ventana }) => {
    const { notificar, handleErroresExtraEnPrincipal } = useContext(GlobalContext);

    const [estadoQ, dispatchQ] = useReducer(QueryServicioReducer, {
        data: [],
        params: {},
        flag: {
            procesandoComando: false,
            procesandoBusquedaUnSoloCliente: false,
        },
        // idClienteSelec: null,
    });

    // const buscarServiciosCommand = new ComandoBuscarServicios();
    const servicioApiQueryServicios = new ServicioQueryServicios();
    const buscarServiciosCommand = new ComandoAPI(servicioApiQueryServicios);
    buscarServiciosCommand.ejecutar = async (paramsQuery) => {
    // buscarServiciosCommand.ejecutar = useHandlerDeComandoConSesionActiva(async (paramsQuery) => {
    // const buscarItems = useHandlerDeComandoConSesionActiva(async (paramsQuery) => {
        /* const clienteAFactPorActualizar = {
            id: estadoDCF.domain.screen.idCliente,
            data: estadoDCF.domain.update,
        }; */

        try {
            const respuestaQuery = await servicioApiQueryServicios.ejecutar(paramsQuery);
            /* const respuestaQuery = await new ServicioDeQueryDeClientesAFacturar().ejecutar(
                paramsQuery
            ); */
            // dispatchQ(new CargaDeItemsBuscados(respuestaQuery.clientes));
            dispatchQ(new CargaDeServiciosBuscados(respuestaQuery.items));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchQ(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            handleErroresExtraEnPrincipal(error);
            // throw error;
        }
    }
    // });

    

    return (
        <DialogoQueryServiciosLayout
            ventana={ventana}
            dispatchQ={dispatchQ}
            estadoQ={estadoQ}
            buscarItems={buscarServiciosCommand}
            // buscarItems={buscarItems}

        />
    );
};

export default DialogoQueryServicios;
